export enum ParticipantRole {
  Unknown = 'Unknown',
  Borrower = 'Borrower',
  SigningAgent = 'SigningAgent',
  NonBorrowingTitleHolder = 'NonBorrowingTitleHolder',
  Seller = 'Seller',
  Witness = 'Witness',
  Signer = 'Signer',
}

export interface ParticipantSummary {
  id: string;
  firstName: string;
  lastInitial: string;
  role: ParticipantRole;
  isPresignComplete: boolean;
}

export interface SigningJoinCodeAddress {
  streetAddress1: string;
  streetAddress2: string;
  city: string;
  stateCode: string;
  zip: string;
}

export interface SigningJoinCodeCapabilities {
  isRemote: boolean;
}

export interface SigningJoinCodeResponse {
  signingId: string;
  signingType: string;
  signingStatus: string;
  propertyAddress: SigningJoinCodeAddress;
  scheduledDateTime: string | null;
  capabilities: SigningJoinCodeCapabilities;
  participants: ParticipantSummary[];
}
